export default __webpack_public_path__ + "base-osm-500-acb9564930b7aac252a6a0f14d0ad0d2.png";